'use strict';

var EXLY_COMMUNITY_FEED_TYPES = {
    COMMUNITY_CHANNEL: 1,
    COMMUNITY: 2,
    // BLOG: 3, // not used
};
var EXLY_COMMUNITY_CHANNEL_TYPES = {
    GROUP_CHAT: 1,
    POST: 2,
    DIRECT_CHAT: 3,
};

exports.EXLY_COMMUNITY_CHANNEL_TYPES = EXLY_COMMUNITY_CHANNEL_TYPES;
exports.EXLY_COMMUNITY_FEED_TYPES = EXLY_COMMUNITY_FEED_TYPES;
//# sourceMappingURL=Miscellaneous.js.map
